<template>
    <v-dialog-old ref="dialog" @hidden="reset">
        <fieldset>
            <legend>Причина отклонения</legend>

            <label v-for="defaultReason in (isDoctor ? doctorReasons : patientReasons)">
                <input type="radio" v-model="reason" :value="defaultReason">
                <span>{{ defaultReason }}</span>
            </label>

            <label>
                <input type="radio" v-model="reason" value="Другое">
                <span>Другая причина</span>
            </label>
            <textarea v-model="reasonText" :disabled="reason !== 'Другое'"/>
        </fieldset>

        <footer>
            <button class="green" @click="rejectAnswer" :disabled="isBtnDisabled()">Отклонить ответ</button>
        </footer>
    </v-dialog-old>
</template>

<script>
    export default {
        props: {
            answerId: {
                type: [Number, String],
                required: true
            },
            uri: {
                type: String,
                required: true
            },
            isDoctor: {
                type: Boolean,
                required: true
            }
        },
        data: () => ({
            reason: null,
            reasonText: null,
            doctorReasons: [
                'Нарушение правил сервиса',
                'Размещение контактов запрещено',
                'Врачам запрещено предлагать собственные услуги вне сервиса и давать контакты',
                'Предоставление неинформативных ответов или ответов, не связанных с вопросом клиента, запрещено',
                'Если у вас есть предложения по улучшению работы сервиса, напишите их, пожалуйста, на почту support@doctu.ru',
                'Текст ответа должен быть развернутым и содержать ответы на все вопросы клиента. Неинформативные ответы запрещены',
                'Рекомендовать консультацию/исследование без развернутого ответа мотивирующего причину такой рекомендации запрещено',
            ],
            patientReasons: [
                'Нарушение правил сервиса',
                'Размещение контактов запрещено',
                'Врачам запрещено предлагать собственные услуги вне сервиса и давать контакты',
                'Вопрос на сервисе не является онлайн-консультацией. Врачи не могут выдавать рецепты',
                'Если у вас есть предложения по улучшению работы сервиса, напишите их, пожалуйста, на почту support@doctu.ru',
                'Сервис предполагает доступность вопроса врачам любых специальностей. В этом суть второго мнения. После получения ответов вы можете выбрать лучшего/лучших специалистов, чьи ответы вы считаете наиболее полезными. Тогда только выбранные вами врачи получат вознаграждение за ответы',
            ],
        }),
        methods: {
            rejectAnswer() {
                if (this.isBtnDisabled()) {
                    return;
                }

                let reason = this.reason === 'Другое' ? this.reasonText : this.reason
                this.axios
                    .post(this.uri + 'reject/' + this.answerId, {reason: reason})
                    .then(response => {
                        this.$emit('updatePlease')
                        this.$bus.fire('updateMenu');
                        this.reset()
                        this.$refs.dialog.hide()
                    })
                    .catch(response => {
                        this.$modal(response.errors.common[0],{
                            name: 'ОК',
                            callback: () => {},
                        },{}, false, 'only-text-dialog');
                    })
            },
            reset() {
                this.reason = null
                this.reasonText = null
            },
            isBtnDisabled() {
                if (!this.reason) {
                    return true;
                }

                if (this.reason === 'Другое' && !this.reasonText) {
                    return true;
                }
            }
        }
    }
</script>

